import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2, AlertTriangle } from "lucide-react";
import { AdminNav } from "../components/site/AdminNav";
import { VehiclesPanel } from "../components/fleet/VehiclesPanel";
import { TiresPanel } from "../components/fleet/TiresPanel";
import { CostSettings } from "../components/fleet/CostSettings";
import { useAuth } from "../lib/auth";
import { api } from "../lib/api";

const TABS = [["unidades", "Unidades e historial"], ["cubiertas", "Cubiertas"], ["costos", "Valores de costos"]];

const Alerts = () => {
  const [a, setA] = useState([]);
  useEffect(() => { api.get("/fleet/alerts").then((r) => setA(Array.isArray(r.data) ? r.data : [])).catch(() => {}); }, []);
  if (!a.length) return null;
  return (
    <div data-testid="fleet-alerts" className="mt-6 rounded-2xl bg-amber-50 p-4 text-sm text-amber-950 ring-1 ring-amber-200">
      <p className="flex items-center gap-2 font-bold"><AlertTriangle className="h-4 w-4" /> {a.length} aviso(s) de service y vencimientos</p>
      <div className="mt-2 grid gap-1 sm:grid-cols-2">{a.map((x, i) => <p key={i} className={x.level === "danger" ? "text-red-800" : ""}>Int. {x.interno}: {x.text}</p>)}</div>
    </div>
  );
};

export default function AdminFlota() {
  const { user } = useAuth();
  const [tab, setTab] = useState("unidades");
  if (user === null) return <div className="grid min-h-[60vh] place-items-center"><Loader2 className="h-6 w-6 animate-spin" /></div>;
  if (!user || !["admin", "taller"].includes(user.role)) return <Navigate to="/admin" replace />;
  const tabs = user.role === "admin" ? TABS : TABS.slice(0, 2);
  return (
    <section data-testid="fleet-page" className="min-h-screen bg-[var(--paper)] px-5 py-10 md:px-10">
      <div className="mx-auto max-w-7xl">
        <AdminNav title="Flota" />
        <Alerts />
        <div className="mt-6 flex flex-wrap gap-2">{tabs.map(([k, l]) => <button key={k} onClick={() => setTab(k)} data-testid={`fleet-tab-${k}`} className={`rounded-full px-5 py-2.5 text-sm font-bold ${tab === k ? "bg-[var(--ink)] text-white" : "bg-white"}`}>{l}</button>)}</div>
        <div className="mt-6">
          {tab === "unidades" && <VehiclesPanel />}
          {tab === "cubiertas" && <TiresPanel />}
          {tab === "costos" && <CostSettings />}
        </div>
      </div>
    </section>
  );
}
